export const MessageTypes = {
  Text: 'text',
  Image: 'Image',
  Audio: 'Audio',
  Video: 'Video'
}

export const ChatroomStatusEnum = {
  Active: 1,
  Blocked: 0
}

export const SidebarListTypes = {
  Chatrooms: 'Chatrooms',
  Users: 'Users'
}

export const BulkUsersFilter = {
  Active: 'active',
  Followers: 'followers',
  Followings: 'followings',
  Subscriber: 'subscribers',
}
